import React from 'react';
import styles from './Form.module.scss';

export interface Props {
  children: React.ReactNode;
}

export default function FormLabel(props: Props) {
  return <label {...props} className={styles.formLabel} />;
}
